var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{attrs:{"id":"categories-detail-komads","frameborder":"1","height":(_vm.height + "px"),"width":"100%","scrolling":"no","src":(_vm.url + "/komads/ctwa/category-detail")}})}
var staticRenderFns = []

export { render, staticRenderFns }